// @mui
import { alpha, useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
//
import Iconify, { IconifyProps } from '../iconify';
//
import { useSettingsContext } from 'src/components/settings/utils';
import { Toaster } from 'sonner';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function SnackbarProvider({ children }: Props) {
  const { themeDirection } = useSettingsContext();
  const theme = useTheme();

  const isRTL = themeDirection === 'rtl';

  return (
    <>
      <Toaster
        closeButton
        theme={theme.palette.mode === 'light' ? 'light' : 'dark'}
        dir={isRTL ? 'rtl' : 'ltr'}
        position="top-right"
        icons={{
          info: <SnackbarIcon icon="eva:info-fill" color="info" />,
          success: <SnackbarIcon icon="eva:checkmark-circle-2-fill" color="success" />,
          warning: <SnackbarIcon icon="eva:alert-triangle-fill" color="warning" />,
          error: <SnackbarIcon icon="eva:alert-circle-fill" color="error" />,
        }}
      />

      {children}
    </>
  );
}

// ----------------------------------------------------------------------

type SnackbarIconProps = {
  icon: IconifyProps;
  color: 'info' | 'success' | 'warning' | 'error';
};

function SnackbarIcon({ icon, color }: SnackbarIconProps) {
  return (
    <Box
      component="div"
      sx={{
        width: 44,
        height: 44,
        display: 'flex',
        borderRadius: 1.5,
        alignItems: 'center',
        justifyContent: 'center',
        color: `${color}.main`,
        bgcolor: (theme) => alpha(theme.palette[color].main, 0.16),
      }}
    >
      <Iconify icon={icon} width={24} />
    </Box>
  );
}
